import { render, staticRenderFns } from "./UserInactive.vue?vue&type=template&id=23a1c13a&scoped=true"
import script from "./UserInactive.vue?vue&type=script&lang=js"
export * from "./UserInactive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a1c13a",
  null
  
)

export default component.exports